export function formatDateTime(ms) {
  if (!ms) return "—";
  return new Date(ms).toLocaleString("tr-TR", { dateStyle: "short", timeStyle: "short" });
}

export function formatNumber(n) {
  return (n || 0).toLocaleString("tr-TR");
}

// YYYY-MM-DD in the browser's time zone, the same shape as the API's byDay keys
export function dayKey(date) {
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export const DEVICE_LABELS = {
  mobile: "Mobil",
  tablet: "Tablet",
  desktop: "Masaüstü",
  bot: "Bot",
};
